var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-root-page"},[_c('div',[_c('open-fund-header',{attrs:{"show-shopping-cart":""}}),_c('router-view')],1),_c('div',{staticClass:"r-footer"},[_c('go-to-signup'),_c('support'),_c('terms-and-conditions-link-buttons')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }